import React from 'react'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'
import ConcreteBanner from './ConcreteBanner'
import ConcreteServices from './ConcreteServices'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'

function Concrete() {
    return (
        <div>
            <ConcreteBanner/>
            <ConcreteServices/>
            <ProjectStats/>
            <TestimonialSlider/>
        </div>
    )
}

export default Concrete
